import { apiFetch, apiUpload } from './client';
import { getToken } from './client';

export type VerificationDocumentType =
  | 'id_card'
  | 'passport'
  | 'driver_license'
  | 'business_registration'
  | 'insurance'
  | 'vehicle_registration'
  | 'other';

export interface VerificationDocument {
  id: string;
  userId: string;
  documentType: VerificationDocumentType;
  filePath: string;
  originalName: string;
  mimeType: string;
  size: number;
  createdAt: string;
  updatedAt: string;
}

type Envelope<T> = { success: true; data: T };

export const listVerificationDocuments = (userId: string) =>
  apiFetch<Envelope<VerificationDocument[]>>(`/api/v1/users/${userId}/verification-documents`);

export const uploadVerificationDocuments = (params: {
  userId: string;
  documentType: VerificationDocumentType;
  files: File[];
}) => {
  const form = new FormData();
  form.set('documentType', params.documentType);
  for (const f of params.files) {
    form.append('documents', f, f.name);
  }
  return apiUpload<Envelope<VerificationDocument[]>>(`/api/v1/users/${params.userId}/verification-documents`, {
    form
  });
};

export const deleteVerificationDocument = (userId: string, docId: string) =>
  apiFetch<Envelope<{ id: string }>>(`/api/v1/users/${userId}/verification-documents/${docId}`, { method: 'DELETE' });

export const getVerificationDownloadUrl = (userId: string, docId: string) =>
  `/api/v1/users/${userId}/verification-documents/${docId}/download`;

export const downloadVerificationDocument = async (userId: string, docId: string) => {
  const token = getToken();
  const res = await fetch(getVerificationDownloadUrl(userId, docId), {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined
  });
  if (!res.ok) throw new Error(`Téléchargement impossible (HTTP ${res.status})`);
  const blob = await res.blob();
  const cd = res.headers.get('content-disposition') || '';
  const match = cd.match(/filename="?([^"]+)"?/i);
  const filename = match?.[1] ?? `document-${docId}`;
  return { blob, filename };
};

